import { styled } from "@material-ui/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
    "& form > .MuiFormControl-root": {
        margin: theme.spacing(0.5, 0),
    },
}));

const TDialog = (props) => {
    return (
        <Dialog fullWidth open={props.open}>
            {props.children}
        </Dialog>
    );
};

const TDialogTitle = (props) => {
    return (
        <DialogTitle style={{ fontWeight: "bold", borderBottom: "1px solid lightgray" }}>
            {props.children}

            {props.allowClose ? (
                <CloseIcon
                    hint="clooooo"
                    onClick={props.onCancel}
                    style={{ height: "30px", width: "30px", cursor: "pointer", float: "right" }}
                />
            ) : null}
        </DialogTitle>
    );
};

const TDialogContent = (props) => {
    return <DialogContent style={{ margin: "10px 0" }}>{props.children}</DialogContent>;
};

const TDialogForm = (props) => {
    return (
        <StyledDialogContent>
            <form method="post" className={props.className}>
                {props.children}
            </form>
        </StyledDialogContent>
    );
};

const TDialogActions = (props) => {
    return <DialogActions style={{ borderTop: "1px solid lightgray" }}>{props.children}</DialogActions>;
};

export { TDialog, TDialogTitle, TDialogContent, TDialogForm, TDialogActions };
